import { items } from './platform_dropdown';

const competitorComparisons = {
  // Main comparison data - each object represents a competitor comparison
  competitors: [
    {
      key: 'cylerian',
      name: 'Cylerian',
      isCylerian: true
    },
    {
      key: 'crowdStrike',
      name: 'CrowdStrike',
      isCylerian: false
    },
    {
      key: 'sophosXDR',
      name: 'Sophos XDR',
      isCylerian: false
    },
    {
      key: 'microsoftSentinel',
      name: 'Microsoft Sentinel',
      isCylerian: false
    },
    {
      key: 'huntress',
      name: 'Huntress',
      isCylerian: false
    }
  ],

  // Feature categories and their comparison points
  // Each category can have direct items or subcategories (but not both)
  features: [
    {
      category: 'Core Features',
      subcategories: [
        {
          name: 'Platform Management',
          items: [
            { feature: 'Multitenancy', crowdStrike: true, sophosXDR: true, microsoftSentinel: true, huntress: true, cylerian: true },
            { feature: 'RBAC', crowdStrike: true, sophosXDR: true, microsoftSentinel: true, huntress: true, cylerian: true },
            { feature: 'Customization', crowdStrike: true, sophosXDR: false, microsoftSentinel: true, huntress: false, cylerian: true }
          ]
        },
        {
          name: 'Asset Management',
          items: [
            { feature: 'Asset Inventory', crowdStrike: true, sophosXDR: 'Add-on', microsoftSentinel: false, huntress: false, cylerian: true },
            { feature: 'Exposure Management', crowdStrike: true, sophosXDR: 'Add-on', microsoftSentinel: false, huntress: false, cylerian: true }
          ]
        },
        {
          name: 'Endpoint Security',
          items: [
            { feature: 'Endpoint Detection and Response (EDR)', crowdStrike: true, sophosXDR: true, microsoftSentinel: false, huntress: true, cylerian: true },
            { feature: 'Device and Application Blocking', crowdStrike: true, sophosXDR: true, microsoftSentinel: false, huntress: false, cylerian: true },
            { feature: 'Remote Shell', crowdStrike: true, sophosXDR: false, microsoftSentinel: false, huntress: false, cylerian: true },
            { feature: 'Deception Technology (Canaries)', crowdStrike: false, sophosXDR: false, microsoftSentinel: false, huntress: true, cylerian: false }
          ]
        },
        {
          name: 'Extended Security',
          items: [
            { feature: 'Email Security', crowdStrike: false, sophosXDR: 'Add-on', microsoftSentinel: false, huntress: true, cylerian: false },
            { feature: 'Identity Threat Detection (ITDR)', crowdStrike: true, sophosXDR: false, microsoftSentinel: false, huntress: true, cylerian: true },
            { feature: 'User Behavior Analytics (UBA)', crowdStrike: true, sophosXDR: false, microsoftSentinel: true, huntress: false, cylerian: true },
            { feature: 'Network Detection and Response (NDR)', crowdStrike: true, sophosXDR: true, microsoftSentinel: false, huntress: false, cylerian: false },
            { feature: 'Extended Detection and Response (XDR)', crowdStrike: true, sophosXDR: true, microsoftSentinel: false, huntress: true, cylerian: true }
          ]
        },
        {
          name: 'Security Operations',
          items: [
            { feature: 'SOAR (Native Automation)', crowdStrike: true, sophosXDR: false, microsoftSentinel: true, huntress: false, cylerian: true },
            { feature: 'SIEM (Native Log Ingestion)', crowdStrike: true, sophosXDR: false, microsoftSentinel: true, huntress: true, cylerian: true },
            { feature: 'Deception (Honeypots)', crowdStrike: false, sophosXDR: false, microsoftSentinel: false, huntress: false, cylerian: true },
            { feature: 'Cloud & SaaS Security (CSPM/SSPM)', crowdStrike: true, sophosXDR: 'Add-on', microsoftSentinel: false, huntress: false, cylerian: true },
            { feature: 'Centralized Log Management (CLM)', crowdStrike: 'Add-on', sophosXDR: false, microsoftSentinel: true, huntress: false, cylerian: true },
            { feature: 'Managed Detection and Response (MDR)', crowdStrike: true, sophosXDR: 'Add-on', microsoftSentinel: false, huntress: true, cylerian: true },
            { feature: 'Forensics and Threat Hunting', crowdStrike: false, sophosXDR: false, microsoftSentinel: true, huntress: true, cylerian: true }
          ]
        },
        {
          name: 'Data & Compliance',
          items: [
            { feature: 'Data Loss Prevention (DLP)', crowdStrike: true, sophosXDR: 'Add-on', microsoftSentinel: false, huntress: false, cylerian: false },
            { feature: 'File Integrity Monitoring (FIM)', crowdStrike: true, sophosXDR: 'Add-on', microsoftSentinel: false, huntress: false, cylerian: true },
            { feature: 'Compliance Tracking', crowdStrike: true, sophosXDR: false, microsoftSentinel: true, huntress: false, cylerian: true },
            { feature: 'Data Retention (Long-term)', crowdStrike: true, sophosXDR: false, microsoftSentinel: true, huntress: false, cylerian: true }
          ]
        },
        {
          name: 'IT & Efficiency',
          items: [
            { feature: 'IT Operations (Observability)', crowdStrike: false, sophosXDR: false, microsoftSentinel: false, huntress: false, cylerian: true },
            { feature: 'Remote Management (RMM Features)', crowdStrike: false, sophosXDR: false, microsoftSentinel: false, huntress: false, cylerian: true },
            { feature: 'AI Security Assistant', crowdStrike: true, sophosXDR: false, microsoftSentinel: false, huntress: false, cylerian: true }
          ]
        }
      ]
    },
  ],

  // Hero section content
  hero: {
    title: 'Cylerian vs. The Competition',
    subtitle: 'See how Cylerian compares to other security and observability platforms',
    description:
      'Unlike traditional point solutions that force you to cobble together multiple products, Cylerian provides a unified platform that brings security, observability, and operations together in one seamless experience.'
  },

  // Call to action
  cta: {
    title: 'Ready to see the difference?',
    description: 'Experience the Cylerian advantage with a free 7-day trial. No credit card required.',
    buttonText: 'Start Free Trial',
    buttonLink: '/contact'
  }
};

export default competitorComparisons;
